export default "__VITE_ASSET__BoOg2CkG__"